import React, { FC } from 'react';
import { Route, Switch, useParams } from 'react-router-dom';
import RemindersCreatePage from './RemindersCreatePage/RemindersCreatePage';
import RemindersCreateSelectTypePage from './RemindersCreateSelectTypePage/RemindersCreateSelectTypePage';
import RemindersHomePage from './RemindersHomePage/RemindersHomePage';
import RemindersEditPage from './RemindersEditPage/RemindersEditPage';

// setting this constant here and not using useRouteMatch as it doesn't always work correctly
const remindersBaseUrl = '/maps/reminders';

const RemindersCreatePageDefault = () => {
  const { reminderType } = useParams<{ reminderType: string }>();
  return <RemindersCreatePage myRemindersItemType={reminderType} />;
};

const RemindersEditPageDefault = () => {
  const { reminderType, reminderId } =
    useParams<{ reminderType: string; reminderId: string }>();
  return (
    <RemindersEditPage
      myRemindersItemType={reminderType}
      myRemindersItemId={reminderId}
    />
  );
};

const RemindersFeature: FC = () => (
  <Switch>
    <Route path={remindersBaseUrl} exact>
      <RemindersHomePage />
    </Route>

    <Route path={`${remindersBaseUrl}/new/select-type`} exact>
      <RemindersCreateSelectTypePage />
    </Route>

    <Route path={`${remindersBaseUrl}/new/:reminderType`} exact>
      <RemindersCreatePageDefault />
    </Route>

    <Route path={`${remindersBaseUrl}/edit/:reminderType/:reminderId`} exact>
      <RemindersEditPageDefault />
    </Route>
  </Switch>
);

export default RemindersFeature;
